import {
  onSortData,
  bufferToWork,
  multiFilterChange,
  getModifiedProjectHeaderNames,
  checkIfOrderSame,
  isRoleMatch
} from "../../../utils";
import moment from "moment";
import _, { isArray, isObject, isEmpty } from "lodash";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
// import CustomisedView from "./CustomisedView";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import ProjectListHeader from "./ProjectListHeader";
import ProjectNameHeader from "./ProjectNameHeader";
import ProjectListFilter from "../ProjectListFilter";
import LoadingOverlay from "react-loading-overlay-ts";
// import { generateUniqueKey } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
// import CustomizeView from "../MyProjects/CustomizeView";
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ProjectService } from "../../../service/PegaService";
import CustomizeView from "../../common/CustomizeView";
import CustomInput from "../../common/CustomInput";
//const CustomisedView = React.lazy(() => import("./CustomisedView"));
import { setAlignFrozenColumn } from "../../../Utils/leftAlignFrozenColumn";
import { selectedProject, SpecialProjectAction } from "../../../store/actions/ProjectSetupActions";
import { getMyProject, updateProjectStatusComment } from "../../../store/actions/ProjectActions";
// import CustomizeViewDialog from "../../DSBP/CustomizeView/CustomizeViewDialog";
import Footer from "../../common/tableFooter/tableFooter";
import ACPFilter from "../../ACP/common/ACPFilter";
import { AcpService } from "../../../service/ACPService";
import { AcpCommonService } from "../../../service/AcpCommonService";
import { getColumnsOrder, setColumnsOrder } from "../../../apis/commonApi";
import { saveProjectsFromDashboard, saveProjectPlanAction } from "../../../apis/projectPlanApi";
import { localWidthStorage } from "../../../utils";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../../common/NavigationPrompt";
import { CharacterLimit } from "../../common/CharacterLimit/CharacterLimit";
import AlertIcon from "../../common/AlertIcon/AlertIcon";
 
const ProjectList = (props) => {
  const { markClean, markDirty } = useUnsavedChangesWarning();
  const flag = props.flag;
  const op = useRef(null);
  const dt = useRef(null);
  const toast = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const filterArray = useRef([]);
  const colAllSelected = useRef([]);
  const currentUrl = location.pathname;
  const selectedFieldsRef = useRef([]);
  const selectedColumnList = useRef([]);
  const [filters, setFilters] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sortData, setSortData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [pegadata, setPegaData] = useState(null);
  const [isSearch, isSearchSet] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [isColWidthSet, setColWidth] = useState(null);
  const [frozenCoulmns, setFrozenColumn] = useState([]);
  const [tableRender, setTableRender] = useState(false);
  const [selectedFields, setSelectedFields] = useState({});
  const [allColumnNames, setAllColumnNames] = useState([]);
  const [ProjectFrozen, setProjectFrozen] = useState(false);
  const [filterCleared, setFilterCleared] = useState(false);
  const [initialPegaData, setInitialPegaData] = useState(null);
  const [ProjectData, setProjectData] = useState(0);
  //let columnWidth = localStorage.getItem("columnWidthMyProject");
  const [isReorderedColumn, setReorderedColumn] = useState(false);
  const [projectColumnName, setProjectColumnNames] = useState([]);
  const [selectedColumnName, setSelectedColumnName] = useState(null);
  const [customizeViewFields, setCustomizeViewFields] = useState([]);
  const [updatedAllColumnNames, setUpdatedAllColumnNames] = useState([]);
  const [initialColumnLenght, setinitialColumnLenght] = useState({});
  const [resizeMode, setResizeMode] = useState("expand");
  const StorageData = localStorage.getItem("customizeViewFieldsMyProjects");
  const customizeViewFieldsStorage = StorageData && JSON.parse(StorageData);
  const [customViewIsAddedMyProject, isCustomViewIsAddedMyProject] = useState(false);
  const user_group = useSelector((state) => state?.UserDetailsReducer?.userDetails?.UserGroup);
  const [availableFields, setAvailableFields] = useState([]);
  const [datatableColumnFromPega, setDatatableColumnFromPega] = useState([]);
  const [pgDefaultColumns, setPGDefaultColumns] = useState({});
  const [editingInProgress, setEditingInProgress] = useState(false);
  const [resetCustomInputs, setResetCustomInputs] = useState(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [currentRows, setCurrentRows] = useState(20);
 
  const User = useSelector((state) => state?.UserReducer);
  const userInformation = User?.userInformation;

  const rowsPerPageOptions = useMemo(() => {
    const totalRecords = filters?.length || pegadata?.length || 0;
    return [
      { label: 20, value: 20 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
      { label: 200, value: 200 },
      { label: 'All', value: totalRecords }
    ];
  }, [filters?.length, pegadata?.length]);

  const paginatorTemplate = {
    layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
    RowsPerPageDropdown: (options) => {
      const handleRowsChange = (e) => {
        setCurrentRows(e.value);
        options.onChange(e);
      };
      
      return (
        <Dropdown
          value={options.value}
          options={rowsPerPageOptions}
          optionLabel="label"
          onChange={handleRowsChange}
          appendTo={document.body}
        />
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: 'auto', textAlign: 'center' }}>
          Showing {options.first} to {options.last} of {options.totalRecords} entries
        </span>
      );
    }
  };
 
 
  const checkIsFilterApplied = () => {
    let isSelectedVal = false;
    if (selectedFields && Object.keys(selectedFields)?.length > 0) {
      isSelectedVal = Object.values(selectedFields)?.some((value) => value.length > 0);
    }
    return isSelectedVal;
  };
  const isFilterEnabled = isSearch || checkIsFilterApplied();
 
  const isResetEnabled = isFilterEnabled || customViewIsAddedMyProject || frozenCoulmns.length > 0;
  const [conditionMatched, setConditionMatched] = useState(false);
 
  const myProjectList = useSelector((state) => state.myProject);
  const [searchHeader, setSearchHeader] = useState({});
  const [globalFilterValue, setGlobalFilterValue] = useState("");
 
  const allColumnNamesConstValue = [
    "Project_ID",
    "Project_Name",
    "Artwork_Category",
    "Artwork_Brand",
    "Artwork_SMO",
    "Project_State",
    "Buffer_To_Work",
    "Estimated_AW_Printer",
    "AWPrinterDate",
    "POAReleaseDate",
    "Artwork_Status",
    "ProjectStatusComment"
  ];

  const isDataUnchanged = useMemo(() => {
    return JSON.stringify(pegadata) === JSON.stringify(initialPegaData);
  }, [pegadata, initialPegaData]);

  useEffect(() => {
    if(isDataUnchanged) {
      markClean()
      setIsSaveEnabled(true)
    } else {
      markDirty()
      setIsSaveEnabled(false)
    }
  }, [isDataUnchanged, markClean, markDirty])
 
  useEffect(() => {
    const fetchColumnFromPega = async () => {
      try {
        let datatableColumnFromPega = await getColumnsOrder(userInformation?.userid, "myProjectsAllColumnNames", "NA", "NA");
        if (datatableColumnFromPega != null && datatableColumnFromPega?.length > 0) {
          setDatatableColumnFromPega(datatableColumnFromPega)
        }
        else {
          let localAllColumns = localStorage.getItem("allColumnNames");
          let _allColumns = JSON.parse(localAllColumns);
          if (isEmpty(_allColumns)) {
            _allColumns = ProjectService.getMyProjectData();
          }
          setDatatableColumnFromPega(_allColumns)
        }
      } catch (err) {
        console.log(err)
      }
    };
    if (userInformation?.userid != undefined)
      fetchColumnFromPega();
  }, [userInformation]);
 
  // const jsonColumnWidth = JSON.parse(columnWidth);
  useEffect(() => {
    let sortingData = JSON.parse(localStorage.getItem("sortingData"));
    if (sortingData && sortingData?.length) {
      onSort(sortingData[0], sortingData[1]);
    }
  }, []);
 
  useEffect(() => {
    let temp = projectColumnName?.reduce((acc, curr) => {
      let matchMode =
        selectedFields[curr] && selectedFields[curr]?.length > 0
          ? FilterMatchMode.IN
          : FilterMatchMode.CONTAINS;
      return {
        ...acc,
        [curr]: {
          value:
            selectedFields[curr] && selectedFields[curr]?.length > 0 ? selectedFields[curr] : null,
          matchMode: matchMode,
        },
      };
    }, {});
 
    if (globalFilterValue !== "") {
      temp["global"] = { value: globalFilterValue, matchMode: FilterMatchMode.CONTAINS };
    }
    setSearchHeader(temp);
  }, [selectedFields, globalFilterValue, projectColumnName]);
 
  const onGlobalFilterKeyword = (e) => {
    setGlobalFilterValue(e.target.value);
  };
 
  const { loading } = myProjectList;
  useEffect(() => {
    if (projectColumnName.length < 6) {
      setResizeMode("fit");
    } else {
      setResizeMode("expand");
    }
  }, [projectColumnName]);
 
  useEffect(() => {
    const ProjectData = _.cloneDeep(myProjectList.myProject);
    let allCol = [];
    if (ProjectData?.length) {
      allCol = Object.keys(ProjectData[0]);
      allCol.push("Artwork_Status");
    }
    let columnWidthMyProject = {};
 
    let getJsonStoredWidthColumns = localStorage.getItem("columnWidthMyProject");
    let getStoredWidthColumns = JSON.parse(getJsonStoredWidthColumns);
    const checkEmptyObject = _.isEmpty(getStoredWidthColumns);
 
    if (checkEmptyObject) {
      localStorage.setItem("columnWidthMyProject", JSON.stringify(columnWidthMyProject));
    }
 
    let jsonColWidth = localStorage.getItem("isColWidthSetMyProject");
    let isColWidthSetFlag = JSON.parse(jsonColWidth);
    if (isColWidthSetFlag) {
      setColWidth(true);
    }
 
    let availableFields;
    const selectedFeilds = ProjectService.getMyProjectData();
    availableFields = allColumnNames?.filter(function (objFromA) {
      return !selectedFeilds.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });
    setinitialColumnLenght({
      availableFields: availableFields.length,
      freezedColumns: 0,
      selectedFields: selectedFeilds.length,
    });
    const selectedFeildsVal = allColumnNamesConstValue
    const customizeViewFieldsUpdated = formCustomizeObject(availableFields, [], selectedFeildsVal);
    setPGDefaultColumns(customizeViewFieldsUpdated);
  }, []);
 
  useEffect(() => {
    if (userInformation?.userid != undefined)
    setToInitialCustomizeView();
 
    getCustomizedView();
  }, [allColumnNames,userInformation]);
 
  useEffect(() => {
    setLoader(true);
    (async () => {
      try {
        // below is json call
        // const ProjectData = await ProjectService.getProjectData();
 
        //below is api call
        const ProjectData = _.cloneDeep(myProjectList.myProject);
        clearFilter();
        if (ProjectData && ProjectData.length) {
          ProjectData.filter((field) => {
            if (field.Artwork_Category) {
              let categoryNames = field?.Artwork_Category?.map((item) => item.Category_Name).join(
                ", "
              );
              field.Artwork_Category = categoryNames;
            }
 
            if (field.Artwork_SMO) {
              let SMOName = field?.Artwork_SMO?.map((item) => item.SMO_Name).join(", ");
              field.Artwork_SMO = SMOName;
            }
 
            if (field.Artwork_Brand) {
              let brandName = field?.Artwork_Brand?.map((item) => item.Brand_Name).join(", ");
              field.Artwork_Brand = brandName;
            }
 
            return field;
          });
        }
 
        if (ProjectData?.length) {
          let allCol = Object.keys(ProjectData[0]);
          allCol.push("Artwork_Status");
         
          if (!allCol.includes("ProjectStatusComment")) {
            allCol.push("ProjectStatusComment");
          }
           
          setAllColumnNames(reorderColumns(allCol));
        }
 
        let filteredPegaDataJson = localStorage.getItem("columnWiseFilterData");
        const filteredPegaData = JSON.parse(filteredPegaDataJson);

        if (filteredPegaData && filteredPegaData.length) {
          setFilters(filteredPegaData);
          setSelectedFields(filteredPegaData);
          setPegaData(ProjectData);
        } else setPegaData(ProjectData);

        const initProjectData = _.cloneDeep(ProjectData);
        setInitialPegaData(initProjectData);
 
        // according to pathname we need to call api and store column name in local storage
        let columnNamesJson = localStorage.getItem("allColumnNames");
        let columnNames = JSON.parse(columnNamesJson);
        if (columnNames && columnNames?.length) {
          // Check if the new column exists in stored columns, if not, use default
          const defaultColumns = ProjectService.getMyProjectData();
          if (!columnNames.includes("ProjectStatusComment")) {
            columnNames = defaultColumns;
          }
          columnNames = AcpService?.removeCommonValues(columnNames, frozenCoulmns);
          columnNames = [...frozenCoulmns, ...columnNames];
          setProjectColumnNames(columnNames);
          setUpdatedAllColumnNames(columnNames);
        } else {
          let columnNames = ProjectService.getMyProjectData();
          columnNames = AcpService?.removeCommonValues(columnNames, frozenCoulmns);
          columnNames = [...frozenCoulmns, ...columnNames];
          setUpdatedAllColumnNames(columnNames);
          setProjectColumnNames(columnNames);
          localStorage.setItem("allColumnNames", JSON.stringify(columnNames));
        }
 
        // get sort data from local storage and add in state
        let jsonSortingData1 = localStorage.getItem("sortingData");
        const sortingData = JSON.parse(jsonSortingData1);
 
        if (sortingData && sortingData.length) {
          const sortedData = onSortData(sortingData[0], sortingData[1], ProjectData);
          setPegaData(sortedData);
          setSortData([sortingData[0], sortingData[1]]);
        }
      } catch (err) {
        console.log("error", err);
      }
    })();
    setLoader(false);
  }, [myProjectList?.myProject]);
 
  const onSearchClick = () => {
    isSearchSet(!isSearch);
  };
 
  const addFrozenColumns = (name) => {
    if (!frozenCoulmns.includes(name)) {
      frozenCoulmns.push(name);
    } else {
      let columnIndex = frozenCoulmns.indexOf(name);
      frozenCoulmns.splice(columnIndex, 1);
    }
    setFrozenColumn(frozenCoulmns);
    const arr = getCustomizedView(true);
    setCustomizeViewFields(arr);
    localStorage.setItem("customizeViewFieldsMyProjects", JSON.stringify(arr));
  };
 
  const reorderColumns = (columns) => {
    const requiredColumnOrderArray = [
      "Project_ID",
      "Project_Name",
      "Initiative_Group_Name",
      "Project_Description",
      "BU",
      "Artwork_Category",
      "Artwork_Brand",
      "Project_region",
      "Artwork_SMO",
      "Cluster",
      "Project_Scale",
      "Project_State",
      "Buffer_To_Work",
      "Estimated_No_Of_DI",
      "Estimated_No_Of_DT",
      "Estimated_No_Of_NPF",
      "Estimated_No_Of_IQ",
      "Estimated_No_Of_PRA",
      "Estimated_No_Of_CICs",
      "Estimated_No_Of_POAs",
      "Estimated_SOS",
      "Estimated_SOP",
      "Estimated_AW_Printer",
      "AWPrinterDate",
      "POAReleaseDate",
      "Estimated_AW_Readiness",
      "IL",
      "Comments",
      "Project_Type",
      "Production_Strategy",
      "Tier",
      "Company",
      "Artwork_Status",
      "ProjectStatusComment",
    ];
 
    let reorderedColumns = [];
    requiredColumnOrderArray.forEach((rcl) => {
      columns.forEach((cl) => {
        if (rcl === cl) {
          reorderedColumns.push(cl);
        }
      });
    });
    return reorderedColumns;
  };
 
  // const resetToPgDefault = async () => {
  //   const allColumnNames = [
  //     "Project_ID",
  //     "Project_Name",
  //     "Artwork_Category",
  //     "Artwork_SMO",
  //     "Project_State",
  //     "Artwork_Brand",
  //     "Buffer_To_Work",
  //     "Estimated_AW_Printer",
  //     "Artwork_Status",
  //   ];
 
  //   localStorage.setItem("allColumnNames", JSON.stringify(allColumnNames));
  //   localStorage.setItem("allColumnNames", JSON.stringify({}));
  //   localStorage.removeItem("isCustomViewIsAddedMyProject");
  //   setProjectColumnNames(allColumnNames);
  //   isCustomViewIsAddedMyProject(true);
  //   setVisible(false);
  // };
 
  const projectNameOnClick = (e, options) => {
    op.current.toggle(e);
    setSelectedColumnName(options);
  };
 
  const sortDataSet = (column, direction, data) => {
    const sortedData = filters?.length ? filters : pegadata;
    const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(sortedData, column, direction);
    //setSelectedProdSrchList(sortedDataSet);
    setSortData([column, direction]);
  };
 
  const onSort = (column, direction, filterData) => {
    const sortedData = filterData?.length? filterData : filters?.length ? filters : pegadata;
    const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(sortedData, column, direction);
 
    setSortData([column, direction]);
    localStorage.setItem("sortingData", JSON.stringify(true));
    if (filterData?.length || filters?.length) {
      setFilters(sortedDataSet);
      selectedColumnList.current = sortedDataSet;
    }else{
      setPegaData(sortedDataSet);
    }
  };

  const confirmNavigation = () => {
    setShowDialog(false);
    markClean();
    navigate(pendingNavigation);
  };

  const cancelNavigation = () => {
    setShowDialog(false);
    setPendingNavigation(null);
  };
 
  const onChangeProjectStatusComment = useCallback(async (option, e, field) => {
    const value = typeof e === "object" && Object.keys(e).length ? e?.target?.value : e;

    setPegaData((prevData) =>
      prevData?.map((project) =>
        project.Project_ID === option.Project_ID ? { ...project, [field]: value } : project,
      ),
    );
      
    // Also update filtered data if filters are active
    if (filters.length > 0) {
      setFilters((prevData) =>
        prevData?.map((project) =>
          project.Project_ID === option.Project_ID ? { ...project, [field]: value } : project,
        ),
      );
    }
 
    // Note: We don't need to save to backend here anymore since
    // the parent component will handle bulk save via the Save button
  }, [pegadata, filters, dispatch, props]);
 
  const fullKitReadinessBody = useCallback((options, rowData) => {
    let field = rowData.field;
    let projectId = options["Project_ID"]; 
    // Show icons only based on project state
    const showRedIcon = options.ChangeHandlingIcon === "Red";
    const showGreyIcon = options.ChangeHandlingIcon === "Grey" || options.ChangeHandlingIcon === "Gray"; // Handle both spellings
    const showAlertIcon = showRedIcon || showGreyIcon;

    return (
      <>
        {field === "Project_ID" && (
          <>
          <span
            style={{ color: "#003DA5", cursor: "pointer" }}
            onClick={(e) => {
              if (field && field.length) {
                let option =
                  isArray(myProjectList.myProject) &&
                  myProjectList.myProject.find((project) => project.Project_ID === projectId);

                const unsavedChanges = JSON.parse(localStorage.getItem("unsavedChanges"));
                if (unsavedChanges) {
                  e.preventDefault();
                  setShowDialog(true);
                  setPendingNavigation(
                    option.Action === "Draft"
                      ? `${currentUrl}/projectSetup/${projectId}`
                      : `${currentUrl}/projectPlan/${projectId}`
                  );
                  return;
                }

                dispatch(selectedProject(option, "My Projects"));
                dispatch(SpecialProjectAction(options?.SpecialProjectFlag));
 
                if (option.Action === "Draft") {
                  navigate(`${currentUrl}/projectSetup/${projectId}`);
                } else {
                  navigate(`${currentUrl}/projectPlan/${projectId}`);
                }
              }
            }}
          >
            {" "}
            {options[field]}{" "}
          </span>
          <span className="my_all_projects_alert_icon_spacing">
            <AlertIcon
              iconType="error"
              showAlertIcon={showAlertIcon}
              onClick={() => navigate(`${currentUrl}/artworkAlignment/${userInformation?.userid}/${projectId}`)}
              editable={showGreyIcon}
              tooltipClass="tooltip-white"
              tooltipText={
                showGreyIcon
                  ? "Grey"
                  : "Active"
              }
              tooltipPosition={"top"}
            />
          </span>  
          </>  
        )}
 
        {field === "Project_Name" && (
          <span
            title={options[field]}
            style={{ color: "#003DA5", cursor: "pointer" }}
            onClick={(e) => {
              if (field && field.length) {
                let option =
                  isArray(myProjectList.myProject) &&
                  myProjectList.myProject.find((project) => project.Project_ID === projectId);

                const unsavedChanges = JSON.parse(localStorage.getItem("unsavedChanges"));
                if (unsavedChanges) {
                  e.preventDefault();
                  setShowDialog(true);
                  setPendingNavigation(
                    option.Action === "Draft"
                      ? `${currentUrl}/projectSetup/${projectId}`
                      : `${currentUrl}/projectPlan/${projectId}`
                  );
                  return;
                }

                dispatch(SpecialProjectAction(options?.SpecialProjectFlag));
 
                dispatch(selectedProject(option, "My Projects"));
                if (option.Action === "Draft") {
                  navigate(`${currentUrl}/projectSetup/${projectId}`);
                } else {
                  navigate(`${currentUrl}/projectPlan/${projectId}`);
                }
              }
            }}
          >
            {options[field]}
          </span>
        )}
 
        {field === "Project State" && (
          <Tag
            value=""
            style={{
              color: "#003DA5",
              border: "1px solid",
              backgroundColor: "#DFEBFF",
            }}
          >
            Active
          </Tag>
        )}
 
        {field === "Artwork_Status" && (
          <Tag
            value="view"
            style={{
              color: "gray",
              margin: "2px 0",
              cursor: "pointer",
              border: "1px solid",
              backgroundColor: "white",
              padding: "0.15rem 0.4rem",
            }}
            onClick={() => window.open(`${currentUrl}/artworkStatus/${projectId}`, '_blank', 'noopener,noreferrer')}
          ></Tag>
        )}
 
        {field === "Estimated_SOP" && <span title={options[field]}>{options[field]}</span>}
        {field === "Estimated_AW_Printer" && <span title={options[field]}>{options[field]}</span>}
        {field === "Buffer_To_Work" && options[field] !== "" && bufferToWork(options[field])}
 
        {field === "Estimated_AW_Readiness" && <span title={options[field]}>{options[field]}</span>}
        {field === "Estimated_SOS" && <span title={options[field]}>{options[field]}</span>}
 
        {field === "ProjectStatusComment" && (
          <>
            <CustomInput
              type="text"
              field={field}
              maxLength={256}
              options={options}
              sortData={sortData}
              value={options[field] || ""}
              fieldType="ProjectStatusComment"
              onChange={onChangeProjectStatusComment}
              filterData={selectedFieldsRef?.current}
              placeholder={"Enter comment"}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
              setEditingInProgress={setEditingInProgress}
            />
            <CharacterLimit field={options[field]} maxLength={256} />
          </>
          
        )}
 
        {field !== "Estimated_AW_Readiness" &&
          field !== "Estimated_AW_Printer" &&
          field !== "Artwork_Status" &&
          field !== "Buffer_To_Work" &&
          field !== "Estimated_SOP" &&
          field !== "Estimated_SOS" &&
          field !== "Project_Name" &&
          field !== "Project_ID" &&
          field !== "ProjectStatusComment" && (
            <>
              {" "}
              <span title={options[field]}>{options[field]}</span>
            </>
          )}
      </>
    );
  }, [myProjectList.myProject, currentUrl, userInformation?.userid, dispatch, onChangeProjectStatusComment, sortData, selectedFieldsRef, resetCustomInputs, navigate]);
 
  // const saveAsPersonaliDefault = (selectedCategories) => {
  //   const columnNames = JSON.stringify(reorderColumns(selectedCategories));
  //   localStorage.setItem("allColumnNames", columnNames);
  //   if (frozenCoulmns.length > 0) {
  //     const columnNames = reorderColumns(selectedCategories);
  //     setAlignFrozenColumn(
  //       frozenCoulmns,
  //       setReorderedColumn,
  //       setProjectColumnNames,
  //       setTableRender,
  //       op,
  //       columnNames
  //     );
  //   } else {
  //     setProjectColumnNames(reorderColumns(selectedCategories));
  //   }
  //   if (selectedCategories.length > 9) {
  //     localStorage.setItem("isCustomViewIsAddedMyProject", JSON.stringify(true));
  //     isCustomViewIsAddedMyProject(true);
  //   }
  //   if (selectedCategories.length === 0) {
  //     isCustomViewIsAddedMyProject(true);
  //   }
  //   setVisible(false);
  // };
 
  const getUpdatedAllColumnFormat = (column) => {
    const finalData = column.map((el) => {
      return {
        width: 250,
        Sequence: "",
        freeze: false,
        Field_Name: el,
        reorder: false,
        Column_Name: el,
        sortAtoZ: false,
        sortZtoA: false,
        Attribute_Type: "Free Text",
      };
    });
    const data = getModifiedProjectHeaderNames(finalData);
    return data;
  };
  const onGlobalFilterChange = (e, colName) => {
    const { value, multiplesFlag, arr } = multiFilterChange(
      e,
      colName,
      selectedColumnName,
      selectedFields,
      setSelectedFields,
      pegadata,
      filterArray,
      selectedColumnList,
      colAllSelected,
      selectedFieldsRef
    );
    const _selectedFieldsRef =
      selectedFieldsRef?.current.length > 0 &&
      selectedFieldsRef?.current.map((el, i) => {
        if (Object.keys(arr)?.[0] === Object.keys(el)?.[0]) {
          return {
            ...el,
            [`${selectedColumnName}`]: arr[selectedColumnName],
          };
        } else {
          return el;
        }
      });
    if (AcpService.areAllPropertiesEmptyArrays(_selectedFieldsRef)) {
      localStorage.removeItem("_selectedFieldsRefCurrentMyProjects");
    }
    if (filterArray.current?.length) {
      const selectedColRes = _.uniqBy(colAllSelected?.current);
      if ((value?.length > 0 && !multiplesFlag) || selectedColRes?.length >= 1) {
        const _selectedFieldsRefWithoutEmptyArray =
          AcpService.removeEmptyArrays(_selectedFieldsRef);
        const filterData = AcpService.filterDataByfilters(
          pegadata,
          _selectedFieldsRefWithoutEmptyArray,
          setConditionMatched,
          "myProjects"
        );
        const convertedObj = AcpCommonService.convertArrayToObject(
          _selectedFieldsRefWithoutEmptyArray
        );
        const uniqueObj = AcpCommonService.getUniqueValuesObject(convertedObj);
        setSelectedFields(uniqueObj);
        if (filterData?.length && sortData?.length) {
          onSort(sortData[0], sortData[1], filterData);
        } else {
          setFilters(filterData);
          selectedColumnList.current = filterData;
        }
      } else {
        selectedColumnList.current = [];
        selectedFieldsRef.current = [];
        setSelectedFields({});
        setFilters([]);
      }
    } else {
      selectedColumnList.current = [];
      selectedFieldsRef.current = [];
      setSelectedFields({});
      setFilters([]);
    }
  };
 
  const formCustomizeObject = (availableFields, freezedColumns, selectedFeilds) => {
    const customizeViewFieldsUpdated = {
      availableFields: {
        id: "availableFields",
        title: "Available Fields",
        fieldsData: availableFields,
      },
      freezedColumns: {
        id: "freezedColumns",
        title: "Freezed Fields",
        fieldsData: freezedColumns,
      },
      selectedFields: {
        id: "selectedFields",
        title: "Selected Fields",
        fieldsData: selectedFeilds,
      },
    };
 
    return customizeViewFieldsUpdated;
  };
 
 
 
  const getAvaiableFeilds = (customizeViewFields) => {
    const availableData = customizeViewFields?.availableFields?.fieldsData
    let availableDataList = []
    if (availableData?.length > 0) {
      availableData.map((item) => {
        const innerObj = {
          Field_Name: item
        }
        availableDataList.push(innerObj)
      })
      setAvailableFields(availableDataList)
    }
  }
 
  const setToInitialCustomizeView = async () => {
    let availableFields;
    const selectedFeildsVal = allColumnNamesConstValue
    availableFields = allColumnNames?.filter(function (objFromA) {
      return !allColumnNamesConstValue?.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });
 
    let customizeViewColumnFromPega = await getColumnsOrder(userInformation?.userid, "customizeViewFieldsMyProjects", "NA", "NA");
    if (customizeViewColumnFromPega != null && customizeViewColumnFromPega != "") {
      setCustomizeViewFields(customizeViewColumnFromPega);
      getAvaiableFeilds(customizeViewColumnFromPega)
      localStorage.setItem("customizeViewFieldsMyProjects", JSON.stringify(customizeViewColumnFromPega));
    }
    else {
      const customizeViewFieldsUpdated = formCustomizeObject(availableFields, [], selectedFeildsVal);
      setCustomizeViewFields(customizeViewFieldsUpdated);
      localStorage.setItem("customizeViewFieldsMyProjects", JSON.stringify(customizeViewFieldsUpdated));
      await setColumnsOrder(userInformation?.userid, "customizeViewFieldsMyProjects", "NA", "NA", false, JSON.stringify(customizeViewFieldsUpdated));
    }
  };
 
  const getCustomizedView = (isFrozen) => {
    const selectedData = customizeViewFieldsStorage?.selectedFields?.fieldsData || [];
    const freezedData = customizeViewFieldsStorage?.freezedColumns?.fieldsData || [];
    const availableData = customizeViewFieldsStorage?.availableFields?.fieldsData || [];
    let availableFields;
    if (availableData?.length > 0) {
      availableFields = availableData;
    } else {
      let updatedColumnFinal = allColumnNames?.filter(function (objFromA) {
        return !projectColumnName.find(function (objFromB) {
          return objFromA === objFromB;
        });
      });
      const intermidaiteColumn = AcpService?.removeCommonValues(
        updatedColumnFinal,
        freezedData?.length ? freezedData : frozenCoulmns
      );
      const availableColumnToSelect = AcpService?.removeCommonValues(
        intermidaiteColumn,
        selectedData?.length ? selectedData : projectColumnName
      );
      availableFields = availableColumnToSelect?.length
        ? availableColumnToSelect
        : updatedColumnFinal;
    }
 
    const freezedColumns = isFrozen
      ? frozenCoulmns
      : freezedData?.length
        ? freezedData
        : frozenCoulmns;
 
    let selectedFields = selectedData?.length ? selectedData : projectColumnName;
    selectedFields = AcpService?.removeCommonValues(selectedFields, freezedColumns);
 
    const customizeViewFieldsUpdated = formCustomizeObject(
      availableFields,
      freezedColumns,
      selectedFields
    );
 
    const column = AcpService?.removeCommonValues(
      selectedFields,
      freezedData?.length ? freezedData : frozenCoulmns
    );
    const projectColumnNamesUpdated = freezedColumns.length > 0 ? [...freezedColumns, ...column] : selectedFields
    setProjectColumnNames(projectColumnNamesUpdated);
    if (!isFrozen) {
      setFrozenColumn(freezedColumns);
      setCustomizeViewFields(customizeViewFieldsUpdated);
    }
    return customizeViewFieldsUpdated;
  };
 
  // const exportCSV = (selectionOnly) => {
  //   dt.current.exportCSV({ selectionOnly });
  // };
 
  const handleCustomizedView = async (data) => {
    if (data !== undefined && data?.length !== 0) {
      const parsedData = data?.selectedFields?.fieldsData?.length > 0
        ? data?.selectedFields?.fieldsData
        : data && JSON.parse(data);
      const freezedData = parsedData?.freezedColumns?.fieldsData || [];
      let selectedData = parsedData?.selectedFields?.fieldsData || [];
      localStorage.setItem("customizeViewFieldsMyProjects", JSON.stringify(parsedData));
      selectedData = AcpService?.removeCommonValues(selectedData, freezedData);
      await setColumnsOrder(userInformation?.userid, "customizeViewFieldsMyProjects", "NA", "NA", false, JSON.stringify(parsedData));
      selectedData = [...freezedData, ...selectedData];
      if (!checkIfOrderSame(ProjectService.getMyProjectData(), selectedData)) {
        isCustomViewIsAddedMyProject(true)
      } else {
        isCustomViewIsAddedMyProject(false)
      }
      //enable reset button if selected feilds order has cahnged
      setProjectColumnNames(selectedData);
      setCustomizeViewFields(parsedData);
      getAvaiableFeilds(parsedData)
      freezedData?.length > 0 && setFrozenColumn([...freezedData]);
      freezedData?.length == 0 && setFrozenColumn([]); //when you drag from frozen to selected reset the state
    }
  };
 
  const storeReorderedColumns = (e) => {
    const dragColumnName = projectColumnName[e?.dragIndex];
    const index = projectColumnName.indexOf(dragColumnName);
    if (index > -1) {
      setReorderedColumn(true);
      projectColumnName.splice(index, 1);
      projectColumnName.splice(e?.dropIndex, 0, dragColumnName);
    }
    localStorage.setItem("allColumnNames", JSON.stringify(projectColumnName));
    setProjectColumnNames(projectColumnName);
    setTableRender(false);
  };
 
  const onColumnResizeEnd = (event) => {
   
    localWidthStorage(event,"columnWidthMyProject")
    localStorage.setItem("isColWidthSetMyProject", JSON.stringify(true));
    setProjectColumnNames(projectColumnName);
    setFilterCleared(false);
    setTableRender(false);
    setColWidth(true);
    setVisible(false);
  };
 
  const clearColumnWiseFilter = () => {
    let _selectedColumnName = selectedColumnName;
    let jsonSortItem = localStorage.getItem("sortingData");
    const sortItem = JSON.parse(jsonSortItem);
    if (sortItem && sortItem.length && sortItem[0] === selectedColumnName) {
      localStorage.setItem("sortingData", JSON.stringify([]));
    }
    if (sortData && sortData?.length && sortData[0] === _selectedColumnName) {
      //setClearAllFilter(true);
      setSortData([]);
    }
 
    const selectedFields2 = _.cloneDeep(selectedFields);
    const _selectedFields = AcpService.emptyProperty(selectedFields2, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);
   
 
    let data = [];
    if (Object.keys(__selectedFields)?.length) {
      data = [...(pegadata || [])];
      Object.keys(__selectedFields).forEach((el) => {
        if (__selectedFields[el]?.length) {
          data = data.filter((ele) => __selectedFields[el].includes(ele[el]));
        }
      });
    }
   
    if (data?.length && Object.keys(__selectedFields)?.length) {
      setFilters(data);
    } else if (sortData?.length && sortData[0] !== _selectedColumnName) {
      selectedColumnList.current = pegadata;
      setFilters([]);
      onSort(sortData[0], sortData[1], pegadata);
    } else {
      setFilters([]);
      const finalInitialData = _.cloneDeep(initialPegaData);
      selectedColumnList.current = finalInitialData;
      setPegaData(finalInitialData);
    }
    setConditionMatched(false);
    selectedFieldsRef.current = __selectedFields;
    setSelectedFields(__selectedFields);
    if (AcpService.areAllPropertiesEmptyArrays(__selectedFields)) {
      localStorage.removeItem("_selectedFieldsRefCurrentMyProjects");
    }
  };
 
  const [resetKey, setResetKey] = useState(0);
 
  const handleChildClick = (isClicked) => {
    if (!isClicked) {
      clearFilter();
      // setResetKey((prev) => prev + 1);
    }
  };
  const dynamicColumns = useMemo(() => {
    if (projectColumnName?.length > 0) {
      return projectColumnName?.map((ele, i) => {
        let jsonColumnWidthMyProject = localStorage.getItem("columnWidthMyProject");
        const columnWidthMyProject = JSON.parse(jsonColumnWidthMyProject);
        let checkWidth = [];
        if (columnWidthMyProject) {
          checkWidth = Object.keys(columnWidthMyProject);
        }
 
        return (
          <Column
            filter
            key={ele}
            field={ele}
            filterField={ele}
            alignFrozen="left"
            columnKey={ele || i}
            showFilterMenu={false}
            filterPlaceholder={ele}
            body={fullKitReadinessBody}
            frozen={frozenCoulmns.includes(ele)}
            // {... checkWidth.includes(ele) && }
            className={frozenCoulmns.includes(ele) ? "font-bold frozen-width" : ""}
            header={ProjectNameHeader(
              ele,
              frozenCoulmns,
              sortData,
              projectNameOnClick,
              selectedFields
            )}
            style={{
              width: projectColumnName?.includes(ele) && columnWidthMyProject
                ? columnWidthMyProject[ele]
                : "auto" ,
                maxWidth: projectColumnName?.includes(ele) && columnWidthMyProject
                ? columnWidthMyProject[ele]  
                : "auto"
            }}
          />
        );
      });
    }
  }, [projectColumnName, frozenCoulmns, sortData, selectedFields, fullKitReadinessBody]);
 
  const clearFilters = () => {
    let allCol = [];
    const ProjectData = _.cloneDeep(myProjectList.myProject);
    if (ProjectData.length) {
      allCol = Object.keys(ProjectData[0]);
      allCol.push("Artwork_Status");
    }
    // let columnWidthMyProject = {};
 
    // localStorage.setItem("columnWidthMyProject", JSON.stringify(columnWidthMyProject));
 
    // localStorage.setItem("allColumnNames", JSON.stringify(allColumnNames));
    localStorage.setItem("columnWiseFilterData", JSON.stringify({}));
    // localStorage.setItem("sortingData", JSON.stringify({}));
    // localStorage.setItem("frozenData", JSON.stringify({}));
    // localStorage.removeItem("isColWidthSetMyProject");
 
    setPegaData(initialPegaData);
    // setReorderedColumn(false);
    setFilterCleared(true);
    setSelectedFields({});
    // setTableRender(true);
    // setColWidth(false);
    isSearchSet(false);
    setVisible(false);
    // setSortData([]);
    setFilters([]);
    setResizeMode("expand");
  };
  const clearFiltersResetToDefault = async (param) => {
    setLoader(true)
    clearFilters();
    isCustomViewIsAddedMyProject(false)
    await clearFiltersResetToPG(param)
    setLoader(false)
  }
 
  const clearFiltersResetToPG = async (param) => {
    setLoader(true)
    localStorage.setItem("customizeViewFieldsMyProjects", JSON.stringify({}));
    await setColumnsOrder(userInformation?.userid, "customizeViewFieldsMyProjects", "NA", "NA", true, "");
    await setColumnsOrder(userInformation?.userid, "myProjectsAllColumnNames", "NA", "NA", true, "");
    setProjectColumnNames(allColumnNamesConstValue);
    await setToInitialCustomizeView()
    setFrozenColumn([]);
    isCustomViewIsAddedMyProject(false);
    if(param==="globalReset"){
    setSortData([]);
    localStorage.removeItem("sortedColumn");
    localStorage.removeItem("columnWidthMyProject");
    localStorage.removeItem("isColWidthSetMyProject");
    }
    setResetKey((prev) => prev + 1);
    setLoader(false)
  }
  const saveSettings = () => {
    localStorage.setItem("sortingData", JSON.stringify(sortData));
    localStorage.setItem("frozenData", JSON.stringify(frozenCoulmns));
    localStorage.setItem("columnWiseFilterData", JSON.stringify(filters));
    localStorage.setItem("allColumnNames", JSON.stringify(projectColumnName));
  };
 
  const clearFilter = () => {
    // localStorage.setItem("columnWiseFilterData", JSON.stringify({}));
    // localStorage.setItem("sortingData", JSON.stringify({}));
    // localStorage.setItem("frozenData", JSON.stringify({}));
    setPegaData(initialPegaData);
    setSelectedFields({});
    // setFrozenColumn([]);
    isSearchSet(false);
    // setSortData([]);
    setFilters([]);
    selectedFieldsRef.current = [];
    if(sortData?.length){
      onSort(sortData[0], sortData[1], initialPegaData);
    }
  };

  const handleSave = async () => {
      try {
        const projectsToSave = pegadata?.filter((project, index) => {
          return project.ProjectStatusComment !== initialPegaData[index].ProjectStatusComment;
        });

        if (!projectsToSave || projectsToSave.length === 0) {
          toast.current?.show({
            severity: 'warn',
            summary: 'Warning',
            detail: 'No projects with comments to save',
            life: 3000
          });
          return;
        }
   
        // Format data according to API specification
        const formData = {
          ArtworkAgilityProjects: projectsToSave.map(project => ({
            AWMProjectID: project.Project_ID, // Using Project_ID as AWMProjectID
            ProjectStatusComment: project.ProjectStatusComment
          }))
        };
   
        // Call the API
        const response = await saveProjectsFromDashboard(formData);
        if (response?.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: 'Success',
            detail: `Successfully saved ${projectsToSave.length} project comment(s)`,
            life: 3000
          });
         
          markClean(); // Mark as clean since changes are saved
          const payLoad = {
            ArtworkAgilityPage: {
              UserGroup: user_group,
              PM: userInformation?.userid,
            },
          };
          dispatch(getMyProject(payLoad));
        } else {
          throw new Error('Failed to save projects');
        }
      } catch (error) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save project comments. Please try again.',
          life: 3000
        });
      }
    };

  const handleCancel = () => {
    if (user_group?.length && userInformation?.userid) {
      const payLoad = {
        ArtworkAgilityPage: {
          UserGroup: user_group,
          PM: userInformation?.userid,
        },
      };
      dispatch(getMyProject(payLoad));
    }

    if(filters.length) {
      const filterData = []

      for(let proj of filters) {
        const filterProj = initialPegaData.filter(pro => pro.Project_ID === proj.Project_ID)
        filterData.push(filterProj[0])
      }
      setFilters(filterData)
    } else {
      setPegaData(initialPegaData)
    }

    markClean();

    toast.current?.show({
      severity: 'info',
      summary: 'Cancelled',
      detail: 'Changes have been discarded',
      life: 3000
    });
  }

  return (
    <>
      <Toast ref={toast} />
      <div className="projectTable myProjectAnddAllProjectList">
        {/* <Suspense fallback={ <Loading />}> */}
        <LoadingOverlay active={loader || loading || pegadata === null} spinner text="">
          <>
              <ProjectListHeader
                filterFLag={false}
                allData={pegadata}
                header={props.header}
                setVisible={setVisible}
                isTreeTableFlag={false}
                // exportCSV={exportCSV}
                headers={projectColumnName}
                CustomizeViewFlag={false}
                clearFilter={clearFilter}
                ResetToDefaultFlag={false}
                clearFilters={clearFilters}
                saveSettings={saveSettings}
                filename="My_Project_Records"
                onSearchClick={onSearchClick}
                isResetEnabled={isResetEnabled}
                isFilterEnabled={isFilterEnabled}
                onGlobalFilterKeyword={onGlobalFilterKeyword}
                selected={filters}
                selectedFields={selectedFields}
                frozenCoulmns={frozenCoulmns}
                sortData={sortData}
                onChildClick={handleChildClick}
                clearFiltersResetToDefault={clearFiltersResetToDefault}
                projectWithStatus={props.projectWithStatus}
                setProjectWithStatus={props.setProjectWithStatus}
              />
           
              <CustomizeView
              availableFields={availableFields || []}
              showTaskDialog={visible}
              headerName={"My Projects"}
              onClose={() => setVisible(false)}
              customizeViewFields={customizeViewFields}
              setCustomizeViewFields={handleCustomizedView}
              resetToPgDefault={clearFiltersResetToPG}
              allColumns={getUpdatedAllColumnFormat(allColumnNames)}
              setResetKey={setResetKey}
              pgDefaultColumns={pgDefaultColumns}
            />

            {/* <ProjectListFilter
              op={op}
              onSort={onSort}
              filters={filters}
              sortData={sortData}
              pageName="My Project"
              projectData={pegadata}
              setFilters={setFilters}
              setSortData={setSortData}
              saveSettings={saveSettings}
              ProjectFrozen={ProjectFrozen}
              frozenCoulmns={frozenCoulmns}
              selectedFields={selectedFields}
              setTableRender={setTableRender}
              setFrozenColumn={setFrozenColumn}
              setProjectFrozen={setProjectFrozen}
              addFrozenColumns={addFrozenColumns}
              projectColumnName={projectColumnName}
              setReorderedColumn={setReorderedColumn}
              selectedColumnName={selectedColumnName}
              onGlobalFilterChange={onGlobalFilterChange}
              setAlignFrozenColumn={setAlignFrozenColumn}
              clearColumnWiseFilter={clearColumnWiseFilter}
              setProjectColumnNames={setProjectColumnNames}
            /> */}
            <ACPFilter
              op={op}
              onSort={onSort}
              pageName={flag}
              filters={filters}
              sortData={sortData}
              setFilters={setFilters}
              tableRender={tableRender}
              setSortData={setSortData}
              saveSettings={saveSettings}
              ProjectFrozen={ProjectFrozen}
              frozenCoulmns={[]}
              selectedFields={selectedFields}
              setTableRender={setTableRender}
              setFrozenColumn={setFrozenColumn}
              setProjectFrozen={setProjectFrozen}
              addFrozenColumns={addFrozenColumns}
              projectColumnName={projectColumnName}
              isReorderedColumn={isReorderedColumn}
              selectedColumnName={selectedColumnName}
              setReorderedColumn={setReorderedColumn}
              onGlobalFilterChange={onGlobalFilterChange}
              setProjectColumnNames={setProjectColumnNames}
              setSelectedColumnName={setSelectedColumnName}
              clearColumnWiseFilter={clearColumnWiseFilter}
              // acpBookingFrozenColumn={acpBookingFrozenColumn}
              projectData={pegadata}
            />

            <DataTable
              ref={dt}
              scrollable
              resizableColumns
              className="mt-3"
              reorderableColumns
              virtualScrollerOptions={currentRows > 200 ? { itemSize: 30 } : null}
              dataKey="Project_ID"
              filters={searchHeader}
              responsiveLayout="scroll"
              columnResizeMode="expand"
              filterDisplay={isSearch && "row"}
              onColReorder={storeReorderedColumns}
              onColumnResizeEnd={onColumnResizeEnd}
              // key={generateUniqueKey("Project_ID")}
              value={filters.length ? filters : pegadata}
              lazy={false}
              rows={currentRows}
              paginator={pegadata?.length > 20}
              paginatorTemplate={paginatorTemplate}
              key={tableRender ? `"Project_ID" + timestamp+${resetKey}` : `${resetKey}`}
              emptyMessage={loader || loading || pegadata === null ? " " : "No records found"}
              // onValueChange={obj =>setFilteredData(obj)}
              tableStyle={{ width: "max-content", minWidth: "100%" }}
            >
              {dynamicColumns}
            </DataTable>
          </>
        </LoadingOverlay>
        {/* </Suspense> */}
      </div>

      {!loader && pegadata && (
        <Footer
          className="footer"
          totalObjects={filters?.length ? filters?.length : pegadata?.length}
          isSelected={false}
          isSaveEnabled={isSaveEnabled}
          handleSave={handleSave}
          handleCancel={handleCancel}
        />
      )}

      <UnsavedChangesDialog
        visible={showDialog}
        onConfirm={confirmNavigation}
        onCancel={cancelNavigation}
      />
    </>
  );
};
export default ProjectList;
 